module.exports = __webpack_public_path__ + "assets/images/ios_ride_this-f44a82eeeddaff363d60741fff4b8d29.webm";